/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';
import { RecentMenu } from './ui/index.tsx';

export const Recent = (): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-recent">
		<JSErrorBoundary fallback="flag" id="recent" packageName={PACKAGE_NAME} teamName={TEAM_NAME}>
			<RecentMenu />
		</JSErrorBoundary>
	</UFOSegment>
);
